import { object, string, type InferType } from 'yup';
import { fileSchema } from '../file/schema';
import { toFileInputDtoList } from '../file/utils';
import type { VideoReplicationInputDto } from './model';

export const videoReplicationFormSchema = object({
  video_file: fileSchema
    .label('原视频')
    .meta({ select: true })
    .min(1, '请上传一个视频')
    .required(),
  reference_images: fileSchema.max(9, '参考图片最多上传 9 张').default([]),
  extra_prompt: string().trim().nullable().default(null),
});

export type VideoReplicationFormValues = InferType<
  typeof videoReplicationFormSchema
>;

export function buildVideoReplicationInput(
  values: VideoReplicationFormValues,
): VideoReplicationInputDto {
  const video = toFileInputDtoList(values.video_file).at(0);
  if (!video) {
    throw new Error('原视频尚未上传完成');
  }

  return {
    video,
    reference_images: toFileInputDtoList(values.reference_images),
    extra_prompt: values.extra_prompt,
  };
}
